import { render, staticRenderFns } from "./LabelBIcon.vue?vue&type=template&id=655aa5f0&"
import script from "./LabelBIcon.vue?vue&type=script&lang=js&"
export * from "./LabelBIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports